<template>
<div :class="$style.root" style="width: 99.9%;margin-left: 1px;">
  <el-card style="height: 98%;">
    <el-tabs :class="$style.tabs" type="border-card" v-model="activeTabName" @tab-click="onTabPaneClick">
      <el-tab-pane
        v-for="item in tabList"
        :key="item.routeName"
        :name="item.routeName"
        :label="item.label">
        <router-link
          :ref="item.routeName"
          slot="label"
          :to="{name: item.routeName}">
          {{item.label}}
        </router-link>
      </el-tab-pane>
    </el-tabs>

    <keep-alive :include="['period-search','stairstep-search']">
      <router-view></router-view>
    </keep-alive>
  </el-card>
</div>
</template>

<script>
export default {
  data() {
    let tabList = [
      {
        label: '时段单价',
        routeName: 'waterfee-pricing-period-search'
      },
      {
        label: '阶梯单价',
        routeName: 'waterfee-pricing-stairstep-search'
      }
    ]
    return {
      tabList: tabList,
      activeTabName: tabList[0].name
    }
  },
  created() {
    this.activeTabName = this.$route.name
  },
  methods: {
    onTabPaneClick(tab) {
      this.$refs[tab.name][0].$el.click()
    },
  }
}
</script>

<style lang="less" module>
.root, .root > :global(.el-card){
  height: 100%;
}
.tabs {
  border-bottom-width: 0;

  :global(.el-tabs__content) {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/sysmodule/waterfee/pricing/index.vue